import { Box, CheckIcon } from "@hightouch/htui";

interface CardSelectionCheckboxProps {
  isSelected: boolean;
  label: string;
  /** Receives the click so a grid can read `shiftKey` for range selection. */
  onToggle: (event: React.MouseEvent) => void;
}

/** Circular selector with a white fill and thin border when checked; the card owns its hover reveal. */
export function CardSelectionCheckbox({
  isSelected: checked,
  label,
  onToggle,
}: CardSelectionCheckboxProps) {
  return (
    <Box
      as="button"
      type="button"
      role="checkbox"
      aria-checked={checked}
      aria-label={label}
      display="flex"
      alignItems="center"
      justifyContent="center"
      cursor="pointer"
      p={0.5}
      bg="transparent"
      border="none"
      borderRadius="full"
      _focusVisible={{ boxShadow: "outline", outline: "none" }}
      // A shift-click would otherwise extend the page's text selection.
      onMouseDown={(e: React.MouseEvent) => {
        if (e.shiftKey) e.preventDefault();
      }}
      onClick={(e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onToggle(e);
      }}
    >
      <Box
        boxSize={5}
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="full"
        color="blackAlpha.80"
        transitionProperty="background-color, border-color"
        transitionDuration="fast"
        transitionTimingFunction="easeOutQuad"
        {...(checked
          ? { bg: "white", border: "1px solid", borderColor: "blackAlpha.40" }
          : { bg: "transparent", border: "2px solid", borderColor: "white" })}
      >
        {/* CheckIcon has internal padding, so it nearly fills the circle to keep the check legible. */}
        <Box
          as={CheckIcon}
          boxSize={4}
          opacity={checked ? 1 : 0}
          transitionProperty="opacity"
          transitionDuration="normal"
          transitionTimingFunction="easeOutQuad"
        />
      </Box>
    </Box>
  );
}
